import { Box, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { Skeleton } from '@material-ui/lab';
import React, { useMemo } from 'react';
import { AlertCard, getAlertCardColors } from '../../../../../../common/cards/alert-card/AlertCard';
import { useUser } from '../../../../../../global/auth/useUser';
import { useVolDashboardMyElementsContext } from '../../VolDashboardMyElementsContext';
import { useSharedAvailabilityCentreDialogState } from '../../../../../../global/components/AvailabilityCenter/AvailabilityCenter';

export const SideBarAvailabilityAlert = () => {
  const { user } = useUser();
  const { configItems } = user;
  const { dialogOpen, setDialogOpen } = useSharedAvailabilityCentreDialogState();
  const { upcomingRosters, sidebarLoading } = useVolDashboardMyElementsContext();
  const { darkTextColor, lightTextColor } = getAlertCardColors('info');

  // Count rosters where availability has been set
  const availabilitySetCount = useMemo(() => {
    if (!upcomingRosters) return 0;
    return upcomingRosters.filter(
      (item) =>
        item &&
        (item.__typename === 'VOLUNTEER_UpcomingRosterAvailabilityType' ||
          item.__typename === 'VOLUNTEER_UpcomingRosterUnavailabilityType')
    ).length;
  }, [upcomingRosters]);

  if (configItems.vm.preventVolunteerAvailabilitySubmission === true) {
    return null;
  }

  return sidebarLoading ? (
    <Skeleton variant='text' width='100%' height={105} style={{ paddingBottom: '24px' }} />
  ) : availabilitySetCount <= 0 ? (
    <Box paddingBottom={3} width='100%'>
      <AlertCard title='Availabilities' variant='info'>
        <Typography variant='subtitle2' style={{ fontSize: '14px', fontWeight: 400, color: lightTextColor }}>
          {`It looks like you haven't set your availability for any volunteering activities in a while.`}
        </Typography>
        <Box>
          <Link
            to={{
              pathname: '/',
            }}
            style={{ textDecoration: 'none' }}
            onClick={() => {
              setDialogOpen(!dialogOpen);
            }}
          >
            <Typography
              variant='body2'
              display='inline'
              style={{ textDecoration: 'underline', color: darkTextColor, fontWeight: 700 }}
            >
              Click here
            </Typography>
          </Link>
          <Typography
            variant='subtitle2'
            display='inline'
            style={{ fontSize: '14px', fontWeight: 400, color: lightTextColor }}
          >
            {' to update your availability, or use the Availabilities Centre in your navigation bar.'}
          </Typography>
        </Box>
      </AlertCard>
    </Box>
  ) : null;
};
